import { useRef, useState, useEffect } from 'react';
import { io, type Socket } from 'socket.io-client';
import { RoomKey, SOCKET_EVENTS } from '@/types';
import { socketConfig, getRoom } from '@/utils/socket';

interface SocketFileParams {
	organization_id: string;
	company_id: string;
}

export function useSocketFile<T = undefined>({ organization_id, company_id }: SocketFileParams) {
	const socketRef = useRef<Socket>();
	const [file, setFile] = useState<T>();

	function handleUpdateFile(file: T): void {
		setFile(file);
	}

	useEffect(() => {
		if (organization_id && company_id) {
			const room = getRoom(RoomKey.FILE_STATUS);
			const config = socketConfig(organization_id, company_id);
			socketRef.current = io(room, config);
			socketRef.current.on(SOCKET_EVENTS.UPDATE_FILE_STATUS, handleUpdateFile);
		}
	}, [organization_id, company_id]); // eslint-disable-line react-hooks/exhaustive-deps

	return { file };
}
